<template>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <require from="framework/html_behaviors/bs-tooltip"></require>
  <require from="components/accommodation-type-panel"></require>
  <require from="controls/as-page-jumbo.html"></require>

  <as-page-jumbo icon="fas fa-hotel fa-fw" heading="Accommodation Types" intro="Manage accommodation types.">
    <div slot="default">
      <div class="sc-buttons-container">
        <button type="button" class="btn btn-light" af-mutex-click.call="createNew()">
          <i class="fas fa-plus"></i> Create new
        </button>
      </div>
    </div>
  </as-page-jumbo>
  <div class="container-fluid">
    <div class="as-form-section">
      <div class="as-widget-list">
        <div class="as-widget-list__item li-accommodation-type-panel" reorderable-repeat.for="item of items" reorderable-dnd-handler-selector.bind="handlerSelector" reorderable-after-reordering="orderChanged">
          <div class="as-widget-list__item-main">
            <accommodation-type-panel control-model.bind="item" changed.bind="item.hasChanged"></accommodation-type-panel>
          </div>
          <div class="as-widget-list__item-controls">
            <div class="fa-lg fa-fw"></div>
            <div class="btn-group-vertical btn-group-sm">
              <button type="button" class="btn btn-icon text-danger" title="Archive" af-mutex-click.call="archiveItem(item)" show.bind="!item.hasChanged && item.data.isActive && item.data.id" bs-tooltip>
                <i class="fas fa-trash"></i>
              </button>
              <button type="button" class="btn btn-icon text-success" title="Restore" af-mutex-click.call="restoreItem(item)" show.bind="!item.hasChanged && !item.data.isActive && item.data.id" bs-tooltip>
                <i class="fas fa-trash-restore"></i>
              </button>
              <button type="button" class="btn btn-icon text-primary" title="Submit" af-mutex-click.call="saveItem(item)" show.bind="item.hasChanged && item.data.isActive" bs-tooltip>
                <i class="fas fa-check"></i>
              </button>
              <button type="button" class="btn btn-icon text-danger" title="Cancel" af-mutex-click.call="cancelItemChanges(item)" show.bind="(item.hasChanged && item.data.isActive) || !item.data.id" bs-tooltip>
                <i class="fas fa-times"></i>
              </button>
              <button type="button" class="btn btn-icon d-none ${!creatingNew ? 'd-sm-block' : ''} __handler ${handlerClass}" disabled.bind="items.length <= 1" data-placement="left" title="Drag to reorder" bs-tooltip>
                <i class="fas fa-grip-lines"></i>
              </button>
              <button type="button" class="btn btn-icon d-md-none" af-mutex-click.call="reorderItem(item, $index - 1)" disabled.bind="!($index > 0)" show.bind="!creatingNew">
                <i class="fas fa-arrow-up"></i>
              </button>
              <button type="button" class="btn btn-icon d-md-none" af-mutex-click.call="reorderItem(item, $index + 1)" disabled.bind="!($index < items.length - 1)" show.bind="!creatingNew">
                <i class="fas fa-arrow-down"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
